// extracted by mini-css-extract-plugin
export var drawerPaper = "_1k-0";
export var itemCard = "_1k-1";
export var itemImage = "_1k-2";